import React from 'react';

const EmailIcon2 = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className={className}
    >
      <path
        d="M21 5H3C2.80109 5 2.61032 5.07902 2.46967 5.21967C2.32902 5.36032 2.25 5.55109 2.25 5.75V18.5C2.25 18.8978 2.40804 19.2794 2.68934 19.5607C2.97064 19.842 3.35218 20 3.75 20H20.25C20.6478 20 21.0294 19.842 21.3107 19.5607C21.592 19.2794 21.75 18.8978 21.75 18.5V5.75C21.75 5.55109 21.671 5.36032 21.5303 5.21967C21.3897 5.07902 21.1989 5 21 5ZM19.0716 6.5L12 12.9828L4.92844 6.5H19.0716ZM20.25 18.5H3.75V7.45531L11.4928 14.5531C11.6312 14.6801 11.8122 14.7506 12 14.7506C12.1878 14.7506 12.3688 14.6801 12.5072 14.5531L20.25 7.45531V18.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default EmailIcon2;
